var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "ul",
      _vm._l(_vm.riga.variazioneRigaDistintaQtaTaglia, function (qta, index) {
        return _c(
          "li",
          { key: "li_" + index },
          [
            _c("div", { staticClass: "gray" }, [_vm._v(_vm._s(qta.desc))]),
            _c(
              "v-row",
              { key: "r_" + index, attrs: { "no-gutters": "" } },
              [
                _c(
                  "v-col",
                  { staticClass: "pl-2", attrs: { "align-self": "center" } },
                  [
                    _c("v-text-field", {
                      staticClass: "mr-2",
                      attrs: {
                        rules: [
                          (v) =>
                            _vm.isValidFieldNumber(v) ||
                            "Quantità per la taglia " +
                              qta.desc +
                              " necessaria",
                        ],
                        autocomplete: "off",
                        label: "Quantità",
                        type: "number",
                        min: "0",
                        disabled: _vm.riga.eliminataDaAs400,
                        "data-test": "quantita-variazione",
                      },
                      on: { input: _vm.inputTextFieldCambiato },
                      model: {
                        value:
                          _vm.riga.variazioneRigaDistintaQtaTaglia[index]
                            .qtaModificata,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.riga.variazioneRigaDistintaQtaTaglia[index],
                            "qtaModificata",
                            _vm._n($$v)
                          )
                        },
                        expression:
                          "riga.variazioneRigaDistintaQtaTaglia[index].qtaModificata",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    attrs: { "align-self": "center" },
                    model: {
                      value:
                        _vm.riga.variazioneRigaDistintaQtaTaglia[index].qta,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.riga.variazioneRigaDistintaQtaTaglia[index],
                          "qta",
                          $$v
                        )
                      },
                      expression:
                        "riga.variazioneRigaDistintaQtaTaglia[index].qta",
                    },
                  },
                  [_vm._v(_vm._s(_vm._f("formatNumber")(qta.qta)))]
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }